import i18n from 'i18next';

export const toMinorUnits = (value: unknown): number => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) {
        throw new Error(i18n.t('common.invalidMonetaryValue'));
    }
    return Math.round(amount * 100);
};
